<template>
  <div
    v-if="number_of_elements"
    class="refonte-pagination">
    <spinner
      v-if="props.loading"
      class="my-0" />
    <template v-else>
      <div
        class="result-label-clickable"
        v-if="props.show_load"
        v-on:click="props.load">
        Afficher plus de résultats
      </div>
      <div class="pb-3">
        {{ props.number_of_elements }} résultats sur
        {{ props.total_of_elements }}
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
  import Spinner from '@/components/utils/spinner.vue';

  const props = withDefaults(
    defineProps<{
      class?: string;
      number_of_elements: number;
      total_of_elements: number;
      load: () => {};
      loading: boolean;
      show_load: boolean;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped>
  .refonte-pagination {
    @apply flex flex-col items-center justify-center self-stretch bg-transparent text-refonte_blue-300;
    gap: 6px;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
  .result-label-clickable {
    @apply flex cursor-pointer bg-transparent text-refonte_blue-300;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 15px !important;
    font-weight: 500 !important;
    line-height: 16px !important;
    &:hover {
      @apply bg-refonte-pale-violet-3;
    }
  }
</style>
